import { render } from "./StatePensionEditor.vue?vue&type=template&id=a22a05d6&ts=true"
import script from "./StatePensionEditor.vue?vue&type=script&lang=ts"
export * from "./StatePensionEditor.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__